<template>
  <div style="width: 100%">
    <h3>移動元が戸建ての場合</h3>
    <div class="mt-2 mb-2">
      <ul>
        <li>
          敷地に面した路上へ移動する場合は<span
            class="bold"
            style="color: green"
            >"隣接する路上"</span
          >を選択してください
        </li>
        <li>敷地外の別住居へ運ぶことはできません（家財おまかせ便をご利用ください）</li>
      </ul>
    </div>
    <div class="text-center mb-2">
      <img :src="filePathKodate" />
    </div>
    <div class="mb-4">
      <table>
        <thead>
          <tr>
            <th>移動元</th>
            <th>移動先</th>
            <th>対応可否</th>
            <th>選択肢</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="4">住宅A</td>
            <td>住宅A (建物内)</td>
            <td>対応可</td>
            <td>建物内</td>
          </tr>
          <tr>
            <td>住宅A (物置や庭)</td>
            <td>対応可</td>
            <td>建物外・敷地内</td>
          </tr>
          <tr>
            <td>隣接する路上</td>
            <td>対応可</td>
            <td>
              <span
                class="bold"
                style="color: green"
                >隣接する路上</span
              >
            </td>
          </tr>
          <tr>
            <td>住宅B</td>
            <td class="not-available">対応不可</td>
            <td>-</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="mt-2"
      style="border-bottom: 1px solid var(--bs-gray-400)"
    ></div>
    <h3 class="mt-3">移動元が集合住宅の場合</h3>
    <div class="mt-2 mb-2">
      <ul>
        <li>
          敷地に面した路上へ移動する場合は<span
            class="bold"
            style="color: green"
            >"自宅外"</span
          >を選択してください
        </li>
        <li>
          同一建物内で異なる号室へ移動する場合は<span
            class="bold"
            style="color: green"
            >"自宅外"</span
          >を選択してください
        </li>
        <li>異なる棟へ運ぶことはできません（家財宅急便をご利用ください）</li>
      </ul>
    </div>
    <div class="text-center mb-2">
      <img :src="filePathShugo" />
    </div>
    <div>
      <table>
        <thead>
          <tr>
            <th>移動元</th>
            <th>移動先</th>
            <th>対応可否</th>
            <th>選択肢</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowspan="4">集合住宅A棟201号室</td>
            <td>集合住宅A棟201号室</td>
            <td>対応可</td>
            <td>自宅内</td>
          </tr>
          <tr>
            <td>集合住宅A棟302号室</td>
            <td>対応可</td>
            <td>
              <span
                class="bold"
                style="color: green"
                >自宅外</span
              >
            </td>
          </tr>
          <tr>
            <td>隣接する路上</td>
            <td>対応可（敷地内の車道含む）</td>
            <td>
              <span
                class="bold"
                style="color: green"
                >自宅外</span
              >
            </td>
          </tr>
          <tr>
            <td>集合住宅B棟</td>
            <td class="not-available">対応不可</td>
            <td>-</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'YhcEFKazaiKaguidoDetailInputDescriptionModal',
  data() {
    return {
      filePathKodate: $core.$imgix.buildUrl('u/qhmzdd1a/kaguido_shikichigai_kodate.png', {
        w: 270,
      }),
      filePathShugo: $core.$imgix.buildUrl('u/0361dehm/kaguido_shikichigai_shugo.png', {
        w: 270,
      }),
    }
  },
}
</script>

<style scoped>
body {
  background-color: #1e1e1e;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #777;
  padding: 8px;
  text-align: left;
}

th {
  background-color: var(--bs-gray-100);
}

.not-available {
  color: #ff6b6b;
  font-weight: bold;
}
</style>
